<template>
    <td :key="tarif_id" :class="`tarif_input_cell ${isTarifUsed(tarif_id) ? '':'tarif-unused'}`">
        <template v-if="isGeneric()">
            <v-text-field
                v-model="getTarif.montant"
                :hide-details="true"
                suffix="€"
                type="number"
            />
        </template>
        <template v-else>
            {{ displayMontant(getTarif.montant) }} €
            <template v-if="getTarif.pourcentage_refaction">
                <p style="font-style: italic; color: #969696;">
                    soit montant net : {{ displayMontant(getMontantTarif(getTarif)) }} €
                </p>
            </template>
        </template>
    </td>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { multiplication, reverseIntConversion } from '../../utils';

export default {
    name: 'TarifCellMontant',
    components: {},
    mixins: [],
    props: {
        tarif_id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapState('collectivite', ['tarifsUsed']),
        ...mapGetters('collectivite', ['getCurrentTarif']),
        getTarif() {
            return this.getCurrentTarif(this.tarif_id);
        },
    },
    watch: {},
    created() {

    },
    methods: {
        isTarifUsed(id) {
            if (this.tarifsUsed.length > 0) {
                return this.tarifsUsed.find((tarifUsed) => tarifUsed.id === id);
            }

            return true;
        },
        isGeneric() {
            return 'simulateur-generique' === this.$route.name;
        },
        getMontantTarif(tarif) {
            return multiplication(tarif.montant, reverseIntConversion(100 - tarif.pourcentage_refaction, 2));
        },
        displayMontant(montant) {
            return Number.parseFloat(montant.toString()).toFixed(2);
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Simulateur/TarifCellMontant.vue